import React, {Component} from 'react';
import "./htmldiff.css";
import {htmlDiffBase} from "./htmldiff-base";
import {Select, Empty} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
const {Option} = Select;

class HtmlDiffRouter extends BaseComponent{

    render() {
        let componentName = this.props.match.params.componentName ? this.props.match.params.componentName : '';
        let id = this.props.match.params.id ? this.props.match.params.id : '';
        let dataType = this.props.match.params.dataType ? this.props.match.params.dataType : '';

        let NewComponent = require(`./${componentName}/${componentName}`).default; // 引入编辑器
        return <NewComponent dataType={dataType} id={id}/>
    }

}

export class Htmldiff extends Component {

    static defaultProps = {
        dataKey : "id",
        dataValue : "name",
        leftDefaultCheckIndex : 0,//左侧默认选中的项
        rightDefaultCheckIndex : 0,//右侧默认选中的项
        leftDataSource:[],//左侧下拉菜单中的数据
        rightDataSource:[],//右侧下拉菜单中的数据
        tagChange: (index)=>{},//内容区域(index : 1)与源码区域(index : 2)切换的时候调用.
        leftSelectOnChange:()=>{},//左侧下拉菜单变化的时候
        rightSelectOnChange:()=>{},//右侧下拉菜单变化的时候
        leftContent: "",
        rightContent: "",
    };

    state = {
        checked: 1,
        leftDataSource: this.props.leftDataSource,
        leftContent: this.props.leftContent,
        rightDataSource: this.props.rightDataSource,
        rightContent: this.props.rightContent,
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.leftDataSource = nextProps.leftDataSource;
        this.state.leftContent = nextProps.leftContent;
        this.state.rightDataSource = nextProps.rightDataSource;
        this.state.rightContent = nextProps.rightContent;
    }

    renderDiff(){
        setTimeout(()=>{
            if(this.state.leftContent && this.state.rightContent){
                let newRightHtml = htmlDiffBase(this.state.leftContent, this.state.rightContent);
                let newLeftHtml = htmlDiffBase(this.state.rightContent, this.state.leftContent);
                this.setState({leftContent: newLeftHtml, rightContent: newRightHtml});
            }
        }, 10);
    }

    render() {
        let renderArea = (data, defaultCheckIndex, selectOnChange, content)=>{
            if(!data || data.length === 0){
                return <div style={{border:"1px solid #0855a5", padding:10}}>
                    <Empty/>
                </div>;
            }
            if(content && this.state.checked !== 1){
                content = content.replace(/<[^>]*>/g, function(label){
                    if(label.startsWith(`<ins `) || label === `</ins>`){
                        return label;
                    }
                    label = label.replace("<", "&lt;");
                    label = label.replace(">", "&gt;");
                    return label;
                });
            }
            return (
                <div style={{border:"1px solid #0855a5", padding:10}}>
                    版本：<Select
                        onChange={selectOnChange}
                        defaultValue={(()=>{
                            let item = data[defaultCheckIndex];
                            if(typeof item === "string"){
                                return item;
                            }else{
                                return item[this.props.dataValue];
                            }
                        })()}
                    >
                        {data.map((item, index)=>{
                            if(typeof item === "string"){
                                return <Option key={index} value={item} title={item}>{item}</Option>;
                            }else{
                                return <Option key={index} value={item[this.props.dataKey]} title={item[this.props.dataValue]}>{item[this.props.dataValue]}</Option>;
                            }
                        })}
                    </Select>
                    <Scrollbars style={{marginTop:10}} autoHeight={true} autoHeightMax={document.body.clientHeight - 260}>
                        <div align={"left"} style={{padding: 10}} dangerouslySetInnerHTML={{__html: content}}></div>
                </Scrollbars></div>)
        };
        return (
            <div className="compare-head">
                <div style={{paddingTop:25}} id="chooseItems">
                    <span style={{fontSize: 30, fontWeight: "bold",color:"white", marginRight: 34, cursor: "pointer"}}
                          onClick={()=> {
                              this.setState({checked: 1});
                              this.props.tagChange(1);
                          }}
                          className={this.state.checked === 1 ? "compare-head-choose" : ""}>内容对比</span>
                    <span style={{fontSize: 24, fontWeight: "bold", color: "white", cursor: "pointer"}}
                          onClick={()=> {
                              this.setState({checked: 2});
                              this.props.tagChange(2);
                          }}
                          className={this.state.checked === 2 ? "compare-head-choose" : ""}>源码对比</span>
                </div>
                <table cellPadding={0} cellSpacing={0} width={"100%"} border={0} style={{margin:40, width:`calc(100% - ${40 * 2}px)`}}><tbody>
                <tr>
                    <td id={"htmlDiffLeftArea"} valign={"top"} style={{width:"50%",padding:20}}>
                        {renderArea(this.state.leftDataSource,
                            this.props.leftDefaultCheckIndex,
                            (value, option)=>{
                                this.props.leftSelectOnChange(value, option).then(content=>{
                                    this.setState({leftContent: content});
                                    this.renderDiff();
                                })
                            },this.state.leftContent)}
                    </td>
                    <td id={"htmlDiffRightArea"} valign={"top"} style={{width:"50%",padding:20}}>
                        {renderArea(this.state.rightDataSource,
                            this.props.rightDefaultCheckIndex,
                            (value, option)=>{
                                this.props.rightSelectOnChange(value, option).then(content=>{
                                    this.setState({rightContent: content});
                                    this.renderDiff();
                                })
                            },this.state.rightContent)}
                    </td>
                </tr>
                </tbody></table>
            </div>
        );
    }
}

export default HtmlDiffRouter;